import { render } from "./rocItem.vue?vue&type=template&id=54a1c488"
import script from "./rocItem.vue?vue&type=script&lang=js"
export * from "./rocItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__